import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '../../../../../components/Button';

const TradeEkspor = ({ i18n, history }) => {
  const lang = (type, params) => i18n(`economy.tab5.${type}`, { ...params });

  return (
    <div className='card-instruction-detail'>
      <div className='title'>{lang('title')}</div>
      <main>
        <div className='instruction-wrap'>
          <div dangerouslySetInnerHTML={{ __html: lang('step.instruction') }} />
          <a
            className='the-btn mtop16 btn btn-primary'
            href='http://inatrade.kemendag.go.id/'
            target='_blank'
            without
            rel='noopener noreferrer'
            style={{ width: 'max-content' }}
          >
            {lang('step.cta1')}
          </a>

          <div
            className='mtop16'
            dangerouslySetInnerHTML={{ __html: lang('step.instruction1') }}
          />
          <Button
            color='primary'
            className='mtop16'
            onClick={() => history.push('/economy/trade-inquiry/form')}
          >
            {lang('step.cta2')}
          </Button>

          <div
            className='mtop16'
            dangerouslySetInnerHTML={{ __html: lang('step.instruction2') }}
          />
          <a
            className='the-btn mtop16 btn btn-third'
            href='https://e-ska.kemendag.go.id/cms.php'
            target='_blank'
            without
            rel='noopener noreferrer'
            style={{ width: 'max-content' }}
          >
            {lang('step.cta3')}
          </a>

          <div
            className='mtop16'
            dangerouslySetInnerHTML={{ __html: lang('step.instruction3') }}
          />
        </div>
      </main>
    </div>
  );
};

TradeEkspor.propTypes = {
  i18n: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default compose(connect(mapStateToProps), withRouter)(TradeEkspor);
